import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost, passengerHost } from "~/Utils";
import { fields } from "../constants";
import { useSubCategoriesDocumentDetails } from "./appfeature.hook";
import { useLocalStorage } from "~/Hooks/useLocalStorage";


 const AddEditFeature = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);

  const {
    data: editSubCategories,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchSubCategories,
  } = useSubCategoriesDocumentDetails(query.get("editId") || "");

  const {
    data: editSubCategoriesById,
    isLoading: isLoadingSubCategories,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchSubCategories();
    }
  }, [query.get("editId"), query.get("id")]);

//   const epcApplicationsFormConfig: FormConfig = {
//   initialValues: {
//     image: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.image)
//       : decodeHTML(editSubCategories?.image),
//     welcomeText: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.welcomeText)
//       : decodeHTML(editSubCategories?.welcomeText),
//     subText: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.subText)
//       : decodeHTML(editSubCategories?.subText),
//     androidQrImage: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.androidQrImage)
//       : decodeHTML(editSubCategories?.androidQrImage),
//     iosQrImage: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.iosQrImage)
//       : decodeHTML(editSubCategories?.iosQrImage),
//     scan_description_en: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.scan_description_en)
//       : decodeHTML(editSubCategories?.scan_description_en),
//     meta_title_en: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.meta_title_en)
//       : decodeHTML(editSubCategories?.meta_title_en),
//     meta_desc_en: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.meta_desc_en)
//       : decodeHTML(editSubCategories?.meta_desc_en),
//     metadataImage: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.metadataImage)
//       : decodeHTML(editSubCategories?.metadataImage),
//     androidText: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.androidText)
//       : decodeHTML(editSubCategories?.androidText),
//     iosText: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.iosText)
//       : decodeHTML(editSubCategories?.iosText),
//     androidLink: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.androidLink)
//       : decodeHTML(editSubCategories?.androidLink),
//     iosLink: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.iosLink)
//       : decodeHTML(editSubCategories?.iosLink),
//     published: editSubCategoriesById?.payload
//       ? decodeHTML(editSubCategoriesById?.payload?.published)
//       : decodeHTML(editSubCategories?.published),
//   },
//   fields: fields.header,
// };
const epcApplicationsFormConfig: FormConfig = {
  initialValues: {
    welcomeText:
      editSubCategoriesById?.payload?.welcomeText ??
      editSubCategories?.welcomeText ??
      "",
    subText:
      editSubCategoriesById?.payload?.subText ??
      editSubCategories?.subText ??
      "",
    androidText:
      editSubCategoriesById?.payload?.androidText ??
      editSubCategories?.androidText ??
      "",
    iosText:
      editSubCategoriesById?.payload?.iosText ??
      editSubCategories?.iosText ??
      "",
    androidLink:
      editSubCategoriesById?.payload?.androidLink ??
      editSubCategories?.androidLink ??
      "",
    iosLink:
      editSubCategoriesById?.payload?.iosLink ??
      editSubCategories?.iosLink ??
      "",
    scan_description_en:
      editSubCategoriesById?.payload?.scan_description_en ??
      editSubCategories?.scan_description_en ??
      "",
    meta_title_en:
      editSubCategoriesById?.payload?.meta_title_en ??
      editSubCategories?.meta_title_en ??
      "",
    meta_desc_en:
      editSubCategoriesById?.payload?.meta_desc_en ??
      editSubCategories?.meta_desc_en ??
      "",
    published:
      editSubCategoriesById?.payload?.published ??
      editSubCategories?.published ??
      false,

    // 🔸 Image fields (handled like banner_image example)
    image: editSubCategoriesById?.payload?.image
      ? [
          {
            uid: "-1",
            name: "main-image.jpg",
            status: "done",
            url: editSubCategoriesById?.payload?.image,
          },
        ]
      : editSubCategories?.image
      ? [
          {
            uid: "-1",
            name: "main-image.jpg",
            status: "done",
            url: editSubCategories?.image,
          },
        ]
      : [],

    androidQrImage: editSubCategoriesById?.payload?.androidQrImage
      ? [
          {
            uid: "-2",
            name: "android-qr.jpg",
            status: "done",
            url: editSubCategoriesById?.payload?.androidQrImage,
          },
        ]
      : editSubCategories?.androidQrImage
      ? [
          {
            uid: "-2",
            name: "android-qr.jpg",
            status: "done",
            url: editSubCategories?.androidQrImage,
          },
        ]
      : [],

    iosQrImage: editSubCategoriesById?.payload?.iosQrImage
      ? [
          {
            uid: "-3",
            name: "ios-qr.jpg",
            status: "done",
            url: editSubCategoriesById?.payload?.iosQrImage,
          },
        ]
      : editSubCategories?.iosQrImage
      ? [
          {
            uid: "-3",
            name: "ios-qr.jpg",
            status: "done",
            url: editSubCategories?.iosQrImage,
          },
        ]
      : [],

    metadataImage: editSubCategoriesById?.payload?.metadataImage
      ? [
          {
            uid: "-4",
            name: "metadata-image.jpg",
            status: "done",
            url: editSubCategoriesById?.payload?.metadataImage,
          },
        ]
      : editSubCategories?.metadataImage
      ? [
          {
            uid: "-4",
            name: "metadata-image.jpg",
            status: "done",
            url: editSubCategories?.metadataImage,
          },
        ]
      : [],
  },
  fields: fields.header,
};

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    //  console.log("hariommm", data);
    let imageKeys: any = [
      "image",
      "androidQrImage",
      "iosQrImage",
      "metadataImage"
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Product Management",
      subModule: "subCategories",
      airportName: currentAirport,
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editSubCategories?.tid || editSubCategoriesById?.payload?.id }),
        ...data,
        // field_sub_categories_status: true,
        // field_sub_created_at: "2023-11-21T10:01:09",
        // field_sub_updated_at: "2025-11-29T10:01:09"
      },
      status: status,
    };

    console.log(payload, "tested");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingSubCategories}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Header`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingSubCategories || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${passengerHost}api/get-mobile-app-header/${editSubCategories?.tid || editSubCategoriesById?.payload?.id}` : `${passengerHost}api/get-mobile-app-header`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};

export default AddEditFeature
